export const maneuverType = {
  OPENING: 'opening',
  CLOSING: 'closing',
  CLOSING_OPENING: 'closing-opening',
  UNDETERMINED: 'undetermined',
  CIRCUIT_BREAKER_UNDETERMINED: 'circuit-breaker-undetermined',
  COMMUTATOR: 'commutator',
  ENGINE: 'engine',
};

export const maneuverSubType = {
  ORPHAN: 'orphan',
  ORDINARY: 'ordinary',
  LEARNING: 'learning',
};

/**
 * Funcionalidades do Ativo. Usada inicialmente para exibir informações do ativo.
 */
export const feature = {
  REGISTRATION_DATA: 'registration-data',
  GENERAL_DATA: 'general-data',
  LOSSES: 'losses',
  COOLING_STAGES: 'cooling-stages',
  FILES: 'files',
};
